import * as React from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";

import {
  TableRow,
  TableCell,
  // CircularProgress,
  withStyles,
} from "@material-ui/core";
import { FolderOpen } from "@material-ui/icons";

import { CompositionStore } from "modules/composition/CompositionStore";
// import classNames from 'classnames';

const styles = (theme) => ({
  group: {
    border: "0px",
    backgroundColor: "unset",
    height: "36px",
  },
  groupCell: {
    padding: "0px",
    fontFamily: "Roboto",
    fontSize: "12px",
    color: "#212121",
    fontWeight: 500,
  },
  link: {
    paddingLeft: "40px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: "#212121",
  },
  groupIcon: {
    verticalAlign: "-webkit-baseline-middle",
  },
  folderIcon: {
    fontSize: "21px",
    marginRight: "15px",
    marginLeft: "10px",
  },
});

type IProps = {
  classes: any;
};

@observer
class GroupContent extends React.Component<IProps> {
  render() {
    const { classes } = this.props;
    return CompositionStore.groupSublevel.map((item) => (
      <TableRow className={classes.group}>
        <TableCell colSpan={3} className={classes.groupCell}>
          <Link
            to={`${location.pathname}/${item.id}`}
            className={classes.link}
            onClick={() => (CompositionStore.loading = false)}
          >
            <span className={classes.groupIcon}>
              <FolderOpen className={classes.folderIcon} />
            </span>
            <span>
              {item.data.description.charAt(0).toUpperCase() +
                item.data.description.slice(1)}{" "}
              ({item.data.initial})
            </span>
          </Link>
        </TableCell>
      </TableRow>
    ));
  }
}

export default withStyles(styles)(GroupContent);



// WEBPACK FOOTER //
// ./src/modules/composition/components/layouts/ChildGroups.tsx